/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Korean
export default {
  'people.menu.renotify.flag.description':
    '모두에게 이메일로 미리 알림을 보내고 있습니다. 이 작업은 최대 1분 정도 걸릴 수 있습니다.',
  'people.menu.renotify.flag.description.confluence': '팀원에게 알림',
  'people.menu.renotify.flag.title': '미리 알림 보내는 중',
  'people.menu.renotify.flag.title.confluence': '초대 이메일을 다시 보내기',
  'people.menu.renotify.menu.description':
    '{userCount, plural, other {{userCount,number}명의 사용자가 {product} 초대를 수락하지 않았습니다. 어떤 사용자가 초대를 놓치고 있는지 확인하고 알림을 보내세요.}}',
  'people.menu.renotify.menu.description.confluence':
    '일부 사용자가 Confluence 초대를 수락하지 않았습니다. 어떤 사용자가 초대를 놓치고 있는지 확인하고 알림을 보내세요.',
  'people.menu.renotify.menu.dismiss': '해제',
  'people.menu.renotify.menu.dismiss.confluence': '나중에',
  'people.menu.renotify.menu.remind': '팀원에게 미리 알림',
  'people.menu.renotify.menu.remind.confluence': '팀원에게 알림',
  'people.menu.renotify.menu.title': '모두를 온보딩했습니까?',
  'people.menu.renotify.modal.copied': '링크가 복사됨',
  'people.menu.renotify.modal.copy': '초대 링크 복사',
  'people.menu.renotify.modal.description':
    '누락된 팀원에게 이메일로 미리 알림을 보내거나 초대 링크를 직접 공유할 수 있습니다.',
  'people.menu.renotify.modal.description.confluence': '초대 이메일을 다시 보내거나 초대 링크를 복사하여 공유하세요.',
  'people.menu.renotify.modal.dismiss': '취소',
  'people.menu.renotify.modal.resend': '미리 알림 보내기',
  'people.menu.renotify.modal.resend.confluence': '초대 다시 보내기',
  'people.menu.renotify.modal.title': '누락된 팀원에게 미리 알림',
  'people.menu.renotify.modal.title.confluence': '초대를 놓친 팀원에게 알림',
  'ptc.pm.collaborators.title': '내 공동 작업자',
  'ptc.pm.error-heading': '오류가 발생했습니다.',
  'ptc.pm.error-image-alt-text': '고장난 로봇과 고치느라 바쁜 몇 명의 사람입니다.',
  'ptc.pm.error-text':
    '이러한 오류를 계속 추적하지만, 페이지를 새로 고친 후에도 문제가 해결되지 않으면 언제든지 문의해 주세요.',
  'ptc.pm.num-members': '{memberCount, plural, other {{memberCount,number}명 구성원}}',
  'ptc.pm.people': '사용자',
  'ptc.pm.teams': '팀',
  'ptc.pm.view-your-profile': '내 프로필 보기',
  'ptc.pm.your-teams.title': '내 팀',
};
